import { ListingModelesPageFiltre } from '@components/listing-modeles-page-filtre/models';
import { Block } from '@shared/models';

export const listingModelesPageFiltreMock = (params: ListingModelesPageFiltre): Block<ListingModelesPageFiltre> => ({
  type: 'listing-modeles-page-filtre',
  data: params,
});
